import { string, bool, any, shape } from 'prop-types';

export default shape({
  siteUrl: string,
  thumbnail: string,
  status: string,
  visibility: bool,
  showOnHomePage: bool,
  description: string,
  thumbnailDominantColor: string,
  isOwner: bool,
  isPremium: bool,
  siteName: string,
  uploadImage: string,
  wasPremium: bool,
  siteFeatures: any,
  metaSiteId: string,
});
